/* Lightweight i18n for the public Transparency portal.
   Languages: English (en), Krio (kri), Mende (men). Static labels only — data stays numeric. */

const STRINGS = {
  en: {
    header_tag: "Open Government · Transparency Portal",
    blurb: "Publicly-published payroll, compliance, and headcount figures. Anonymised — no personal information disclosed. Updated continuously from the SaloneHCM platform.",
    as_of: "As of",
    verified_by: "Verified by",
    kpi_headcount: "Total civil servants",
    kpi_headcount_sub: (n) => `Across ${n} ministries`,
    kpi_gross: "Monthly gross payroll",
    kpi_gross_sub: "Active employees",
    kpi_paye: "Monthly PAYE remitted",
    kpi_paye_sub: "To NRA",
    kpi_nassit: "Monthly NASSIT",
    kpi_nassit_sub: "Employee + Employer",
    by_ministry: "By ministry",
    by_ministry_sub: "Ranked by monthly gross payroll. Headcount only — no individual data is disclosed.",
    th_num: "#",
    th_ministry: "Ministry",
    th_headcount: "Headcount",
    th_gross: "Gross / month",
    th_paye: "PAYE / month",
    th_nassit: "NASSIT / month",
    last_payroll: "Most recent payroll",
    no_runs: "No payroll runs yet.",
    ran_on: "Run on",
    filings_12m: "NRA filings (last 12 months)",
    returns_filed: "returns filed",
    no_filings: "No filings recorded.",
    most_recent_filing: "Most recent:",
    footer_verified: "Verified compliance with NRA PAYE bands and NASSIT employer/employee schedules",
    footer_powered: "Powered by",
    footer_ogp: "Open Government Partnership initiative",
    portal_not_found: "Transparency portal not found",
    language_label: "Language",
  },
  kri: {
    header_tag: "Open Govment · Transparency Portal",
    blurb: "Payroll, compliance, ɛn how many pipul de wok, all pɔblik. Wi nɔ de mark eni pesin individwal — nain dis kɔmpyuta de pul out anonymously. We de apdet am stak from di SaloneHCM platform.",
    as_of: "As of",
    verified_by: "Verified bay",
    kpi_headcount: "Olketa civil servant",
    kpi_headcount_sub: (n) => `Akrɔs ${n} ministri dɛm`,
    kpi_gross: "Mɔnsh gross payroll",
    kpi_gross_sub: "Active wokpipul",
    kpi_paye: "Mɔnsh PAYE de pe",
    kpi_paye_sub: "To NRA",
    kpi_nassit: "Mɔnsh NASSIT",
    kpi_nassit_sub: "Wokpipul + Empleya",
    by_ministry: "By ministri",
    by_ministry_sub: "We rank am bay mɔnsh gross payroll. Headcount nɔmɔ — no eniwan personal data nɔ de show.",
    th_num: "#",
    th_ministry: "Ministri",
    th_headcount: "Pipul kount",
    th_gross: "Gross / mɔnsh",
    th_paye: "PAYE / mɔnsh",
    th_nassit: "NASSIT / mɔnsh",
    last_payroll: "Las payroll",
    no_runs: "Nɔ payroll run yet.",
    ran_on: "Wi run am pan",
    filings_12m: "NRA filing dɛm (las 12 mɔnsh)",
    returns_filed: "filing don file",
    no_filings: "Nɔ filing yet.",
    most_recent_filing: "Las wan:",
    footer_verified: "Verified compliance wit NRA PAYE bands ɛn NASSIT employee/employer schedules",
    footer_powered: "Wi run dis sayit wit",
    footer_ogp: "Open Government Partnership initiative",
    portal_not_found: "Wi nɔ fɛn dis transparency portal",
    language_label: "Langwej",
  },
  men: {
    // Mende (mainline Southern + Eastern Sierra Leone). Labels are short translations.
    header_tag: "Wuyei Ngɔvenmɛnt · Hɔɛti Sahaa",
    blurb: "Mu langi ngi yia jia bɛ ji ngɔvenmɛnt-wai bondo wai-i hɔɛti longo ji a ye lɔ. Mu nyande na mu nyaha ngeya yia wai mu va na. Mua yia hu via lɔ wai SaloneHCM.",
    as_of: "Ngiɛ ka",
    verified_by: "Tii hu na",
    kpi_headcount: "Wovumɛi gbi",
    kpi_headcount_sub: (n) => `Ngɔvɔ ministri ${n} ma`,
    kpi_gross: "Kɔɛi mɔ payroll",
    kpi_gross_sub: "Wovumɛi gbi",
    kpi_paye: "Kɔɛi mɔ PAYE",
    kpi_paye_sub: "Ngi NRA va",
    kpi_nassit: "Kɔɛi mɔ NASSIT",
    kpi_nassit_sub: "Wovumɛi + Empleya",
    by_ministry: "Ministri ma",
    by_ministry_sub: "Lɔ kɔɛi mɔ payroll hu. Wovumɛi gbi — kaa ngowɛi yia wai mu va na.",
    th_num: "#",
    th_ministry: "Ministri",
    th_headcount: "Wovumɛi",
    th_gross: "Kɔɛi / mɔ",
    th_paye: "PAYE / mɔ",
    th_nassit: "NASSIT / mɔ",
    last_payroll: "Tewa payroll",
    no_runs: "Payroll yia wai na.",
    ran_on: "Mu ya pii ngi",
    filings_12m: "NRA filing (mɔ 12 woma)",
    returns_filed: "filing tii hu na",
    no_filings: "Filing yia wai na.",
    most_recent_filing: "Tewa wai:",
    footer_verified: "Tii hu wai NRA PAYE bonda ɛɛ NASSIT empleya/wovumɛi nya gbi",
    footer_powered: "Mu pii ngi a",
    footer_ogp: "Wuyei Ngɔvenmɛnt Partnership",
    portal_not_found: "Mu tɛɛ ti hɔɛti sahaa ji",
    language_label: "Lɛɛ",
  },
};

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "kri", label: "Krio" },
  { code: "men", label: "Mɛnde" },
];

export function t(lang, key, ...args) {
  const dict = STRINGS[lang] || STRINGS.en;
  const val = dict[key] ?? STRINGS.en[key] ?? key;
  return typeof val === "function" ? val(...args) : val;
}
